import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function LegalShell({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 bg-background/80 backdrop-blur border-b border-border">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center gap-2">
          <Link to="/"><Button variant="ghost" size="icon" aria-label="Back"><ChevronLeft className="h-5 w-5" /></Button></Link>
          <div>
            <div className="text-xs text-muted-foreground">BallBoy</div>
            <div className="font-semibold bb-display">{title}</div>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6 prose prose-invert prose-headings:bb-display max-w-none">
        {updated && <p className="text-xs text-muted-foreground">Last updated: {updated}</p>}
        {children}
      </main>
      <footer className="max-w-3xl mx-auto px-4 py-6 text-xs text-muted-foreground flex justify-between">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </div>
  );
}
